//#region Asset Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/button'
import 'devextreme/ui/form'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/popup'
import 'devextreme/ui/select_box'

//#endregion

import { IUserSession } from '../../../helpers/user-session'
import { Api, LocalDictionaryFactory } from '../../api/api.module'
import { CommonHelper } from '../../../helpers/common-helper'
import { i18n } from '../../common/i18n/common.i18n'
import { DescrModel } from '../../api/api.models'
import { ConfigHelper, TemplateHelper } from '../../../helpers'

//#region Asset Imports

import './select-add-descr.scss'
import * as TEMPLATE from './select-add-descr.tpl.html'

//#endregion

export enum DescrType {
    ItemType = 1,
    ItemField = 2
}

export interface SelectAddDescrScope extends ng.IScope {
    elementId: number
    propertyName: string
    current: DescrModel
    descriptions: DescrModel[]
    type: DescrType
    callback: (elementId: number, propertyName: string, descr: DescrModel) => void

    selectBoxOptions: DevExpress.ui.dxSelectBoxOptions
    textBoxOptions: DevExpress.ui.dxTextBoxOptions
    addNewDescrbuttonOptions: DevExpress.ui.dxButtonOptions
    popupOptions: DevExpress.ui.dxPopupOptions
    addDescrFormOptions: DevExpress.ui.dxFormOptions
    applyButtonOptions: DevExpress.ui.dxButtonOptions
    cancelButtonOptions: DevExpress.ui.dxButtonOptions

    selectBox: DevExpress.ui.dxSelectBox
    textBox: DevExpress.ui.dxTextBox
    addNewDescrbutton: DevExpress.ui.dxButton
    popup: DevExpress.ui.dxPopup
    addDescrForm: DevExpress.ui.dxForm
    applyButton: DevExpress.ui.dxButton
    cancelButton: DevExpress.ui.dxButton

    formItems: any[]
    formData: any

    acceptButtonDisabled: boolean
    isLoading: boolean
}

export class SelectAddDescrDirective implements ng.IDirective {
    isPopupVisible: boolean
    description: DescrModel

    constructor() { }

    restrict = 'E'
    scope = {
        elementId: '=',
        propertyName: '@',
        current: '=',
        descriptions: '=',
        type: '=',
        callback: '=',
        disabled: '='
    }

    controller = ['$scope', '$q', '$timeout', 'api', 'userSession', 'localDictionary', ($scope: SelectAddDescrScope, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, userSession: IUserSession, localDictionary: LocalDictionaryFactory) => {
        $scope.acceptButtonDisabled = true

        $scope.selectBoxOptions = {
            value: $scope.current ? $scope.current.idDescr : -1,
            bindingOptions: {
                items: 'descriptions',
                disabled: 'disabled'
            },
            displayExpr: 'description',
            valueExpr: 'idDescr',
            onInitialized: e => {
                $scope.selectBox = e.component
            },
            noDataText: i18n('Common', 'NoData'),
            placeholder: i18n('Common', 'Select'),
            onSelectionChanged: e => {
                if ($scope.callback) $scope.callback($scope.elementId, $scope.propertyName, e.selectedItem)
            }
        }

        $scope.textBoxOptions = {
            value: $scope.current ? $scope.current.description : null,
            readOnly: true,
            onInitialized: e => {
                $scope.textBox = e.component
            },
            onValueChanged: e => {
                //if ($scope.callback) $scope.callback($scope.elementId, $scope.propertyName, this.description) textField is readOnly. what for that calback?
            }
        }

        $scope.addNewDescrbuttonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.EDIT, userSession),
            hint: i18n('Common', 'Edit'),
            onInitialized: e => {
                $scope.addNewDescrbutton = e.component
            },
            bindingOptions: {
                disabled: 'disabled'
            },
            onClick: e => {
                this.isPopupVisible = !this.isPopupVisible
                $scope.popup.toggle(this.isPopupVisible)
            }
        }

        $scope.isLoading = true

        $scope.popupOptions = {
            maxWidth: 500,
            maxHeight: 500,
            title: i18n('Popup', 'AddDescr'),
            onInitialized: e => {
                $scope.popup = e.component
            },
            onHidden: e => {
                this.isPopupVisible = false
            },
            onShowing: e => {
                $scope.isLoading = true
            },
            onShown: e => {
                loadData().finally(() => {
                    $scope.isLoading = false
                })
            }
        }

        const idLanguage: number = userSession.getDataProvider().System.getCurrentLanguageId()

        $scope.applyButtonOptions = {
            text: i18n('Common', 'Apply'),
            height: 34,
            onInitialized: e => {
                $scope.applyButton = e.component
            },
            bindingOptions: {
                disabled: 'acceptButtonDisabled'
            },
            onClick: e => {
                let langId = $scope.current ? $scope.current.idLanguage || idLanguage : idLanguage

                if ($scope.formData[langId] && $scope.formData[langId].description) {
                    const descr: DescrModel = new DescrModel()
                    descr.idLanguage = langId
                    descr.idDescr = $scope.current ? $scope.current.idDescr : 0
                    descr.description = $scope.formData[langId].description || _.find($scope.formData, (data: any) => data.description.length > 0).description
                    descr.opState = $scope.formData[langId].opState
                    descr.allLanguagesDescription = $.map($scope.formData, data => [data])
                    descr.allLanguagesDescription = descr.allLanguagesDescription.filter(langDesc => !(!langDesc.description))
                    if ($scope.type == DescrType.ItemField) {

                        if (!$scope.descriptions)
                            $scope.descriptions = []

                        if (descr.idDescr === 0) {
                            descr.idDescr = getnewIdDescr()
                            $scope.descriptions.push(descr)
                            $scope.selectBox.option('value', descr.idDescr)
                        }
                        else {
                            let currentDescr = _.find($scope.descriptions, d => d.idDescr === descr.idDescr)
                            if (currentDescr)
                                currentDescr.description = descr.description

                            $scope.selectBox.repaint()

                            if (_.isFunction($scope.callback)) {
                                $scope.callback($scope.elementId, $scope.propertyName, descr)
                            }
                        }
                    } else {
                        $scope.textBox.option('value', descr.description)
                        
                        if (_.isFunction($scope.callback)) {
                            $scope.callback($scope.elementId, $scope.propertyName, descr)
                        }
                    }

                    this.description = descr

                    $scope.popup.hide()
                }
                else {
                    CommonHelper.openInfoPopup(i18n('Popup', 'FillCurrentLanguage'), 'warning', 4000)
                }
            }
        }

        $scope.cancelButtonOptions = {
            text: i18n('Common', 'Cancel'),
            height: 34,
            onInitialized: e => {
                $scope.cancelButton = e.component
            },
            onClick: e => {
                $scope.popup.hide()
                resetFormData()
            }
        }

        $scope.addDescrFormOptions = {
            colCount: 1,
            scrollingEnabled: true,
            height: '100%',
            bindingOptions: {
                items: 'formItems',
                formData: 'formData'
            }
        }

        const resetFormData = () => {
            for (let i in $scope.formData) {
                $scope.formData[i] = {}
            }
            $scope.acceptButtonDisabled = true
        }

        const getnewIdDescr = () => {
            const descrIds = $scope.descriptions.map(descr => descr.idDescr)
            descrIds.push(1000000)

            let newId = Math.max(...descrIds) + 1
            return newId
        }

        var loadData = () => {
            return localDictionary.getDashboardDictionary().then(() => {
                return localDictionary.getReferenceTable(CommonHelper.IdLanguage, null).then(result => {
                    $scope.formItems = []
                    $scope.formData = {}

                    if (!result || !result.selectBoxData) return

                    result.selectBoxData.forEach(lang => {
                        if ($scope.current) {
                            $scope.formData[lang.id] = _.clone(_.find($scope.current.allLanguagesDescription, langDesc => {
                                return langDesc.idLanguage == lang.id
                            }))
                        }

                        if (!$scope.formData[lang.id]) {
                            $scope.formData[lang.id] = <DescrModel>{
                                idDescr: $scope.current ? $scope.current.idDescr : 0,
                                description: null,
                                idLanguage: lang.id,
                                opState: $scope.current && $scope.current.idDescr ? CommonHelper.ChangeState.Loaded : CommonHelper.ChangeState.New,
                                allLanguagesDescription: []
                            }
                        }

                        var isRequired: boolean = lang.id == idLanguage ? true : false

                        $scope.formItems.push({
                            itemType: 'group',
                            colCount: 1,
                            caption: lang.caption,
                            items: [
                                <DevExpress.ui.dxFormSimpleItem>{
                                    dataField: lang.id + '.idLanguage',
                                    value: lang.id,
                                    label: {
                                        text: i18n('Common', 'Text')
                                    },
                                    visible: false,
                                },
                                <DevExpress.ui.dxFormSimpleItem>{
                                    dataField: lang.id + '.description',
                                    label: {
                                        text: i18n('Common', 'Text')
                                    },
                                    isRequired: isRequired,
                                    editorOptions: {
                                        onValueChanged: e => {
                                            if ($scope.formData[lang.id]) {
                                                $scope.formData[lang.id].description = e.value

                                                if ($scope.formData[lang.id].description)
                                                    $scope.acceptButtonDisabled = false

                                                if ($scope.formData[lang.id].opState == CommonHelper.ChangeState.Loaded)
                                                    $scope.formData[lang.id].opState = CommonHelper.ChangeState.Modified

                                                if ($scope.current) {
                                                    if (!_.find($scope.current.allLanguagesDescription, langDesc => langDesc.idLanguage == lang.id))
                                                        $scope.formData[lang.id].opState = CommonHelper.ChangeState.New
                                                }
                                            }
                                        }
                                    }
                                }
                            ],
                        })
                    })
                })
            })
        }
    }]
    template = TEMPLATE
    transclude = true
}